export const proposalRequestStatus = Object.freeze({
  Submitted: 1, //Sometida
  Returned: 2, //Devuelta
  Assigned: 3, //Asignada
  EvaluationProcess: 4, //En Proceso de Evaluación
  Evaluated: 5, //Evaluada
  PreliminaryRecommended: 9, //Recomendada Preliminar
  NotPreliminaryRecommended: 10, //No recomdada Preliminar
  NotRecommended: 11, //No Recomendada
  NotRecommendedInformation: 12, //No Recomendada - Solicitud de Informacion
  Recommended: 13, //Recomendada
  RecommendedCondition: 15, //Recomendada-Condicion
  SentBudget: 16, //Enviado Presupuesto
  ContractOffice: 17, //Oficina de Contrato
  SecretaryOffice: 18, //Oficina del Secretario
  PendingShippingOGP: 19, //Pendiente de Envio OGP
  OGPApprovalApplication: 20, //Solicitud Aprobación OGP
  OGPApproval: 21, //Aprobación OGP
  OfficeSecretaryForSignature: 22, //Oficina del Secretario para firma
  ReadyForSignature: 23, //Listo para Firma
  SignedContract: 24, //Contrato Firmado
  RegisteredContractOC: 25, //Contrato Registrado OC
  NotRecommendedInformationSubmitted: 26, //No Recomendada - Solicitud de Informacion Sometida
  PartialRecommendation: 27,
  RequirementsDoesNotAccomplish: 28, // No Cumple Requisitos
  RecommendedHiring: 29, // Recomendado-Contratacion
  FundSeparation: 30, // Separacion de Fondos
  SentToSecretaryOffice: 31, // Enviado a Oficina del Secretario
  PendingOGP: 32, // Pendiente OGP
  SentOGP: 33, // Enviado OGP
  ContractDrafting: 34, // Redaccion de Contrato
  InSigningProcessSAEE: 35, // En Proceso de Firma SAEE
  InSigningProcessSupplier: 36, // En Proceso de Firma Proveedor
  InSigningProcessSecretary: 37, // En Proceso de Firma Secretario
  Signed: 38, // Firmado
  DeliveredForObligation: 39, // Entregado para Obligación
  InSigningProcessLegalDivision: 40, //En Proceso de Firma División Legal
  RegistryComptrollerOffice: 41, //Registro Oficina Contralor
  InApprovalAndPOCreationProcess: 42, //En Proceso de Aprobación y Creación de PO
});

export const proposalRequestStatusGroup = Object.freeze({
  SentBudget: Object.freeze({
    id: proposalRequestStatus.SentBudget,
    name: 'Enviado Presupuesto',
  }),
  ContractOffice: Object.freeze({
    id: proposalRequestStatus.ContractOffice,
    name: 'Oficina de Contrato',
    action: 'identificar',
    get question() {
      return `como recibida en la ${this.name}`;
    },
  }),
  SecretaryOffice: Object.freeze({
    id: proposalRequestStatus.SecretaryOffice,
    name: 'Oficina del Secretario',
    action: 'enviar',
    get question() {
      return `a la ${this.name}`;
    },
  }),
  PendingShippingOGP: Object.freeze({
    id: proposalRequestStatus.PendingShippingOGP,
    name: 'Pendiente Envío OGP',
    action: 'enviar',
    get question() {
      return `a la ${proposalRequestStatusGroup.ContractOffice.name}, para la solicitud de aprobación a OGP`;
    },
  }),
  OGPApprovalApplication: Object.freeze({
    id: proposalRequestStatus.OGPApprovalApplication,
    name: 'Solicitud Aprobación OGP',
    action: 'solicitar aprobación a OGP',
    get question() {
      return '';
    },
  }),
  OGPApproval: Object.freeze({
    id: proposalRequestStatus.OGPApproval,
    name: 'Aprobación OGP',
    action: 'solicitar aprobación a OGP',
    question: '',
  }),
  OfficeSecretaryForSignature: Object.freeze({
    id: proposalRequestStatus.OfficeSecretaryForSignature,
    name: 'Oficina del Secretario para firma',
    get action() {
      return `solicitar aprobación a ${this.name} para`;
    },
    question: '',
  }),
  ReadyForSignature: Object.freeze({
    id: proposalRequestStatus.ReadyForSignature,
    name: 'Listo para Firma',
    customAction: 'de que la propuesta',
    get question() {
      return `está ${this.name.toLocaleLowerCase()}`;
    },
  }),
  SignedContract: Object.freeze({
    id: proposalRequestStatus.SignedContract,
    name: 'Contrato Firmado',
    customAction: 'de que la propuesta de contrato',
    question: 'está firmado',
  }),
  RegisteredContractOC: Object.freeze({
    id: proposalRequestStatus.RegisteredContractOC,
    name: 'Contrato Registrado OC',
    customAction: 'que el contrato',
    question: 'fue registrado en la Oficina del Contralor',
  }),
  //Recommendation Panel StatusGroup
  PreliminaryRecommendation: Object.freeze({
    title: 'Recomendación Preliminar',
    statusName: '{verb} preliminar',
    customOptions: false,
    options: [
      proposalRequestStatus.PreliminaryRecommended,
      proposalRequestStatus.NotPreliminaryRecommended,
    ],
  }),
  FinalRecommendation: Object.freeze({
    title: 'Recomendación Final',
    statusName: '{verb} final',
    customOptions: true,
    options: [
      {
        id: proposalRequestStatus.Recommended,
        name: 'Recomendada',
        action: 'si',
      },
      {
        id: proposalRequestStatus.RecommendedCondition,
        name: 'Recomendada - Condición',
        customMsg: '{verb} con condición',
      },
      {
        id: proposalRequestStatus.NotRecommendedInformation,
        name: 'No Recomendada - Solicitud de Información',
        action: 'no',
        customMsg: '{verb} con solicitud de información',
      },
      {
        id: proposalRequestStatus.NotRecommended,
        name: 'No Recomendada',
        action: 'no',
      },
    ],
  }),
});
